import React, { useEffect } from "react";
import Navbar from "./components/Website/navbar";
// import Navbar2 from "../components/Website/navbar2";
import './website.css';
import Hero2 from "./components/Website/hero2";
import BestPlaces from "./components/Website/bestPlaces";
import Process from "./components/Website/process";
import Break from "./components/Website/break";
import Packages from "./components/Website/packages";

function Website() {

    return (
        <div className="website">
            <Navbar />
            <Hero2 />
            <BestPlaces />
            <Process />
            <Break />
            <Packages />
        </div>
    );
}

export default Website;
